import React from "react";
import styled from "styled-components";

import { Carousel } from "@global";
import Hero from "@shared/hero";
import { CarouselLeftArrow } from "@shared/shared.styles";
import {
  assets,
  isAnathoth,
  isEveryday,
  MOBILE_BREAKPOINT,
} from "@util/constants";
import { isBrowser } from "@util/helper";

interface Props {
  hero: Queries.Maybe<Queries.SanityHero> | undefined;
  additionalHeros: readonly Queries.Maybe<Queries.SanityHero>[];
  homeHero?: boolean;
}

const HeroCarousel = (props: Props) => {
  const { hero, additionalHeros, homeHero } = props;
  const heroHeight = isEveryday ? "100%" : "900px";

  if (!isBrowser())
    return <Hero homeHero={homeHero} sanityHero={hero} height={heroHeight} />;

  const NextIcon = (
    <CarouselLeftArrow
      position="absolute"
      right="5px"
      hideOnMobile
      isAnathoth={isAnathoth}
    >
      <img src={assets.arrowRight} alt="right-arrow" />
    </CarouselLeftArrow>
  );

  const PrevIcon = (
    <CarouselLeftArrow
      rightArrow
      position="absolute"
      left="5px"
      hideOnMobile
      isAnathoth={isAnathoth}
    >
      <img src={assets.arrowRight} alt="left-arrow" />
    </CarouselLeftArrow>
  );

  return (
    <Wrapper>
      <Carousel
        hideArrow={false}
        iconButton
        prevIcon={PrevIcon}
        nextIcon={NextIcon}
        hideOnMobile
        speed={30000}
        adaptiveHeight={false}
      >
        <Hero homeHero={homeHero} sanityHero={hero} height={heroHeight} />
        {additionalHeros.map(hero => {
          if (!hero) return null;
          return (
            <Hero
              key={hero?._key}
              homeHero={homeHero}
              sanityHero={hero}
              noH1
              height={heroHeight}
            />
          );
        })}
      </Carousel>
    </Wrapper>
  );
};

export default HeroCarousel;

const Wrapper = styled.div`
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: inherit !important;
  }

  .slick-prev {
    left: 5px;
  }

  .slick-next {
    right: 5px;
  }

  .slide {
    height: 100%;
  }
  .slick-dots li button {
    &:before {
      color: var(--theme-primary-color);
      font-size: 7px;
    }
  }

  #hero-wrapper {
    @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
      min-height: 520px;
    }
  }
`;
